import React from "react"
import TableRow from "material-ui/Table/TableRow"
import EquipmentTimecardTableDay from "./EquipmentTimecardTableDay"
import { IPunchSetDocument, ITimecardDay } from "../../models"
interface IProps {
    fullPunchSets: IPunchSetDocument[]
    timecardDays: ITimecardDay[]
    timecardLocked: boolean
    readonly: boolean
    hierarchyItemId: string
    positionId: string
    addPunch(timecardDay: ITimecardDay, hierarchyItemId: string, positionId: string, payClassId: string, payTypeId: string, employeeId: string, shiftId: string, jobId: string, phaseId: string, isPunchIn: boolean, pairedPunchId: string): void
    onTimeChange(punchId: string, dateTime: Date | string, errorCb: () => void): void
    onConfirmDelete(punchId: string): void
    reloadTimecard(msg: string): void
}

const EquipmentTimecardTableRow: React.SFC<IProps> = (props: IProps) => {
    return (
        <TableRow className="EquipmentTimecardTableRow">
            {props.timecardDays.map((timecardDay, i) =>
                <EquipmentTimecardTableDay
                    fullPunchSets={props.fullPunchSets}
                    day={timecardDay}
                    key={i}
                    addPunch={props.addPunch}
                    onTimeChange={props.onTimeChange}
                    onConfirmDelete={props.onConfirmDelete}
                    timecardLocked={props.timecardLocked}
                    readonly={props.readonly}
                    hierarchyItemId={props.hierarchyItemId}
                    positionId={props.positionId}
                    reloadTimecard={props.reloadTimecard}
                />
            )}
        </TableRow>
    )
}

export default EquipmentTimecardTableRow
